export default __webpack_public_path__ + "icon_delete_input.e4141be0fddb2c821b9ef8c7aa38ea86.svg";